export default __webpack_public_path__ + "media/Emotions.4d8dcda2.svg";